module.exports = {
      id: "number-circle-usage",
      viewBox: "0 0 74 74",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#number-circle",
      toString: function () {
        return this.url;
      }
    }